/* example
    const loader = new Loader();
*/

export default class Loader{
    constructor(){
        this.loader = document.querySelector('.preloader__status'); 
        this.preloader = document.querySelector('#preloader');
        this.bindEvents();
    } 
    bindEvents(){
        window.addEventListener('load', ()=>{
            this.onLoad();
        });        
    }
    onLoad(){
        this.loader.classList.add('is-hidden');
        setTimeout(function() {
            this.preloader.classList.add('is-hidden');
        }, 350);
        setTimeout(function() {
            document.querySelector('body').style.overflow = "auto"; 
        }, 550);
        this.preloader.style.display = 'none';
    }
} 